import React from "react";
import TooltipV2 from "@ui/TooltipV2";
import OverlayWrapper from "@ui/TooltipV2/OverlayWrapper";
import ButtonIconV2 from "@ui/ButtonIconV2";
import t from "../../../i18n";
import { AedLine, Attachment2, FlagLine } from "@ui/IconV2/react";
import { css } from "@linaria/core";

type CTA =
  | "edit-analysis"
  | "edit-analysis-outside-of-event-range"
  | "edit-attach_files"
  | "edit-event"
  | "edit-event-under-development";

const Cta = ({
  ctaType,
  check,
  onClick,
  disabled = false,
}: {
  ctaType: CTA;
  check: boolean;
  onClick: () => void;
  disabled?: boolean;
}) => (
  <TooltipV2
    placement="bottom"
    overlay={<OverlayWrapper className={styledOverlayWrapper} text={getCtaTooltip(ctaType)} />}
  >
    <div>
      <ButtonIconV2 data-cy={ctaType} checked={check} disabled={disabled} onClick={onClick}>
        {getCtaIcon(ctaType)}
      </ButtonIconV2>
    </div>
  </TooltipV2>
);

export default Cta;

//#region CSS
const styledOverlayWrapper = css`
  max-width: 350px;
`;
//#endregion CSS
//#region Function
const getCtaIcon = (cta: CTA) => {
  switch (cta) {
    case "edit-analysis":
    case "edit-analysis-outside-of-event-range":
      return <FlagLine size="s" />;
    case "edit-event":
    case "edit-event-under-development":
      return <AedLine size="s" />;
    case "edit-attach_files":
      return <Attachment2 size="s" />;
    default:
      throw new Error(cta satisfies never);
  }
};
const getCtaTooltip = (cta: CTA) => {
  switch (cta) {
    case "edit-analysis":
      return t("comments.tooltip.connect_current_analysis");
    case "edit-analysis-outside-of-event-range":
      return t("comments.tooltip.analysis_outside_of_event_range");
    case "edit-event":
      return t("comments.tooltip.associate_event");
    case "edit-event-under-development":
      return t("comments.tooltip.feature_under_development");
    case "edit-attach_files":
      return t("comments.tooltip.feature_under_development");
    default:
      throw new Error(cta satisfies never);
  }
};
//#endregion Function
